import { render, staticRenderFns } from "./PhoneVerificationDialog.vue?vue&type=template&id=9964992c&scoped=true&"
import script from "./PhoneVerificationDialog.vue?vue&type=script&lang=js&"
export * from "./PhoneVerificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./PhoneVerificationDialog.vue?vue&type=style&index=0&id=9964992c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9964992c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VForm,VOtpInput,VRow})
